import styled from 'styled-components';
import { Layout } from '../../ui';

export const StyledContent: typeof Layout.Content = styled(Layout.Content)`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
`;
